import type { PropsWithChildren } from 'react';
import NavBar from '@components/navigation';
import Footer from '@components/footer/Footer';

const ErrorLayout = ({ children }: PropsWithChildren) => {
  return (
    <>
      <NavBar />
      {children}
      <Footer />
    </>
  );
};

export default ErrorLayout;
